"use strict";

class SuperAnalyticsController {
    constructor($scope, $timeout, $parse, SSHttpService, SSUtilService, SSAppService, SSAlertService, OTPService, SSUserService, SSDateService) {
        const self = this;

        self.$scope = $scope;
        self.$parse = $parse;
        self.$timeout = $timeout;

        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSAppService = SSAppService;
        self.SSAlertService = SSAlertService;
        self.OTPService = OTPService;
        self.SSUserService = SSUserService;
        self.SSDateService = SSDateService;

        self.data = SHOWSUITE.data;
        self.LARAVEL_REPORT_SERVER_URL = SHOWSUITE.LARAVEL_REPORT_SERVER_URL;

        self.filtered_properties = [];

        self.allReportStatus = [
            {
                id: 11,
                name: 'All'
            },
            {
                id: 30,
                name: 'OTP Issued'
            },
            {
                id: 32,
                name: 'SPA Issued'
            },
            {
                id: 37,
                name: 'Exercised'
            },
            {
                id: 35,
                name: 'OTP Aborted'
            }
        ];

        self.optionIssuedReportStatuses = [
            {
                id: 11,
                name: 'All'
            },
            {
                id: 51,
                name: 'OTP Issued'
            },
            {
                id: 35,
                name: 'OTP Aborted'
            }
        ];

        self.uraReportStatuses = [

            {
                id: 1,
                name: 'All'
            },
            {
                id: 2,
                name: 'Sold'
            },
            {
                id: 3,
                name: 'Aborted'
            },
            {
                id: 4,
                name: 'Re-issue'
            }
        ];

        self.reportParamErrors = {};

        if (self.SSUserService.isSuper()) {
            self.init();
        }
    }

    // ===============================================================================>
    init() {
        const self = this;

        // WEB-3937: Only call GET sec/super/reports when the user has the
        // "View Reports" permission, otherwise the request 403s and shows a
        // "Forbidden!" banner on the analytics page for super users without it.
        if (self.SSUserService.hasPermission('SS_REPORTS_VIEW')) {
            self.getAllReports();
        }
    }

    getAllReports() {
        const self = this;

        self.reports = null;

        let url = 'sec/super/reports';
        let prams = {
            type: 20
        }

        loading(true);
        self.SSHttpService.getAPIRequest(url, prams).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.reports = response.data.reports;
        });
    }

    getReportDescription(developerReport) {
        const self = this;

        let report = self.reports.find(function (report) {
            return report.id === developerReport.id;
        });

        return report ? report.description : '--';
    }

    getReport(developerReport) {
        const self = this;

        let report = self.reports.find(function (report) {
            return report.id === developerReport.id;
        });
        return report ? report : null;
    }

    openDownloadReportModal(developerReport) {
        const self = this;
        self.selectedDownloadReport = null;
        self.selectedDownloadReport = self.getReport(developerReport);

        self.getProperties();

        let statuses = null;
        if (self.selectedDownloadReport.show_status == 1)
            statuses = self.allReportStatus;
        else if (self.selectedDownloadReport.show_ura_status == 1)
            statuses = self.uraReportStatuses;
        else if (self.selectedDownloadReport.show_option_issued_status == 1)
            statuses = self.optionIssuedReportStatuses;

        self.reportParams = {
            statuses: statuses
        };

        self.selected_property = '';

        self.$timeout(function () {
            $(".dashboard-select").niceSelect('update');
        });
        self.filtered_properties = [];

        if (statuses)
            self.reportParams.statuses.forEach(function (value) {
                value.check = false;
            });

        if (self.selectedDownloadReport) {
            $('#downloadReportModal').modal('show');
            self.selectedDownloadReport.name = developerReport.name;
            $('#from_date').datepicker({
                changeMonth: true,
                changeYear: true,
                dateFormat: 'dd/mm/yy'
            });
            $('#to_date').datepicker({
                changeMonth: true,
                changeYear: true,
                dateFormat: 'dd/mm/yy'
            });
        }
    }

    getStatusCheck() {
        const self = this;
        if (!self.selectedDownloadReport || !self.selectedDownloadReport.hasOwnProperty('code')) {
            return false;
        }
        if (self.selectedDownloadReport.code == 'URA2' || self.selectedDownloadReport.code == 'URA3')
            return false;
        if (self.selectedDownloadReport)
            return self.selectedDownloadReport.show_status || self.selectedDownloadReport.show_ura_status || self.selectedDownloadReport.show_option_issued_status;
    }

    getProperties() {
        const self = this;

        self.properties = [];
        let url = 'properties/customized';

        loading(true);
        self.SSHttpService.getAPIRequest(url, {
            offset: 0,
            limit: 1000,
            property_selected_fields: 'id,name,developer_id'
        }).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (response.data && response.data.properties) {
                self.properties = response.data.properties.filter(function (property) {
                    return property.id;
                });

                self.$timeout(function () {
                    $(".dashboard-select").niceSelect('update');
                });
            }

        });
    }

    updateFilter() {
        const self = this;

        if (!self.selected_property) {
            self.filtered_properties = [];
        } else {
            // Don't process if property already filtered
            let property = self.filtered_properties.find(x => x.id == self.selected_property.id);
            if (property) {
                return;
            }

            self.filtered_properties.push(self.selected_property);
        }
    }

    removeFilteredProperty(property_id) {
        const self = this;

        self.filtered_properties = $.grep(self.filtered_properties, function (obj, index) {
            return obj.id !== property_id;
        });
    }

    statusClicked(status) {
        const self = this;
        self.reportParams.report_status = status.id;

        self.reportParams.statuses.forEach(function (value) {
            value.check = false;
            if (value.id == status.id) {
                value.check = true;
            }
        });
    }

    validateReportParams() {
        const self = this;

        let check = true;

        /** WEB-3169 Reports: Separate Settings for From and To Dates
        if (self.selectedDownloadReport.show_date_range && !self.reportParams.from_date) {
            self.reportParamErrors.from_date = 'From date cannot be empty';
            check = false;
        }

        if (self.selectedDownloadReport.show_date_range && !self.reportParams.to_date) {
            self.reportParamErrors.to_date = 'To date cannot be empty';
            check = false;
        }

        if (self.reportParams.from_date) {
            let from_date = moment(self.reportParams.from_date, "DD/MM/YYYY").format("YYYY-MM-DD");
            let to_date = moment(self.reportParams.to_date, "DD/MM/YYYY").format("YYYY-MM-DD");
            if (from_date > to_date) {
                self.reportParamErrors.from_date = 'From date cannot be later than To date';
                check = false;
            }
        }

        if (self.reportParams.to_date) {
            let from_date = moment(self.reportParams.from_date, "DD/MM/YYYY").format("YYYY-MM-DD");
            let to_date = moment(self.reportParams.to_date, "DD/MM/YYYY").format("YYYY-MM-DD");
            if (to_date < from_date) {
                self.reportParamErrors.to_date = 'To date cannot be earlier than From date';
                check = false;
            }
        }**/

        if (self.selectedDownloadReport.show_date_from && !self.reportParams.from_date) {
            self.reportParamErrors.from_date = 'From date cannot be empty';
            check = false;
        }

        if (self.selectedDownloadReport.show_date_to && !self.reportParams.to_date) {
            self.reportParamErrors.to_date = 'To date cannot be empty';
            check = false;
        }

        if (self.selectedDownloadReport.show_date_from
                && self.reportParams.from_date && self.reportParams.to_date) {
            let from_date = moment(self.reportParams.from_date, "DD/MM/YYYY").format("YYYY-MM-DD");
            let to_date = moment(self.reportParams.to_date, "DD/MM/YYYY").format("YYYY-MM-DD");
            if (from_date > to_date) {
                self.reportParamErrors.from_date = 'From date cannot be later than To date';
                check = false;
            }
        }

        if (self.selectedDownloadReport.show_date_to
                && self.reportParams.to_date && self.reportParams.from_date) {
            let from_date = moment(self.reportParams.from_date, "DD/MM/YYYY").format("YYYY-MM-DD");
            let to_date = moment(self.reportParams.to_date, "DD/MM/YYYY").format("YYYY-MM-DD");
            if (to_date < from_date) {
                self.reportParamErrors.to_date = 'To date cannot be earlier than From date';
                check = false;
            }
        }

        if (self.selectedDownloadReport.show_property && !self.selected_property) {
            self.reportParamErrors.show_property = 'Select Property';
            check = false;
        }

        return check;

    }

    downloadReport() {

        const self = this;
        let url = '';
        let url_ping = '';

        if (!self.validateReportParams())
            return;

        self.reportParamErrors.show_property = '';
        if (self.reportParams.from_date) {
            self.reportParams.from_date = moment(self.reportParams.from_date, "DD/MM/YYYY").format("YYYY-MM-DD");
        }

        if (self.reportParams.to_date) {
            self.reportParams.to_date = moment(self.reportParams.to_date, "DD/MM/YYYY").format("YYYY-MM-DD");
        }

        // WEB-3591: both helpers return a URL ending in a query separator and
        // carry no api_token; the same-origin proxy authenticates the request
        // server-side. The '&param=' appends below are therefore unchanged.
        if (self.selectedDownloadReport.is_old_report) {
            url = self.SSHttpService.getApiURL(self.selectedDownloadReport.url);
        } else {
            url = self.SSHttpService.getReportURL(self.selectedDownloadReport.url);
        }

        /** WEB-3169 Reports: Separate Settings for From and To Dates
        if (self.selectedDownloadReport.show_date_range) {
            url += '&from_date=' + self.reportParams.from_date;
            url += '&to_date=' + self.reportParams.to_date;
        }**/

        if (self.selectedDownloadReport.show_date_from) {
            url += '&from_date=' + self.reportParams.from_date;
        }
        if (self.selectedDownloadReport.show_date_to) {
            url += '&to_date=' + self.reportParams.to_date;
        }

        if (self.getStatusCheck())
            url += '&status=' + self.reportParams.report_status;

        if (self.selectedDownloadReport.allow_multiple_properties) {
            let selected_properties = '';
            self.filtered_properties.forEach(function (value) {
                selected_properties += value.id + ',';
            });
            selected_properties = selected_properties.slice(0, -1);
            url += '&property_id=' + selected_properties;
            // self._addReportHistory(selected_properties);
            url_ping = window.open(url, '_blank');
        } else {

            if (self.filtered_properties.length) {
                let selected_property = '';
                self.filtered_properties.forEach(function (value) {
                    selected_property += value.id;
                    url += '&property_id=' + selected_property;
                    // self._addReportHistory(selected_property);
                    url_ping = window.open(url, '_blank');
                    selected_property = '';
                });

            } else {
                url_ping = window.open(url, '_blank');
            }
        }

        if (url_ping) {
            self.SSAlertService.success("Success!", "Download completed successfully");
        }
        $('#downloadReportModal').modal('hide');
    }

    _addReportHistory(properties) {
        const self = this;

        let url = 'sec/developer/reports-history';

        let params = {
            name: self.selectedDownloadReport.alias,
            from_date: self.reportParams.from_date,
            to_date: self.reportParams.to_date,
            status: self.reportParams.report_status,
            allow_multiple_properties: self.selectedDownloadReport.allow_multiple_properties,
            property_ids: properties
        };
        let report_url = '';

        // WEB-3591: the API downloads this URL itself (ReportHistoryService),
        // so it must stay an absolute upstream URL rather than a proxy path.
        if (self.selectedDownloadReport.is_old_report) {
            report_url = self.SSHttpService.getUpstreamApiURL(self.selectedDownloadReport.url);
        } else {
            report_url = self.LARAVEL_REPORT_SERVER_URL + self.selectedDownloadReport.url;
        }

        params.url = report_url;

        self.SSHttpService.postAPIRequest(url, params).then(function (response) {

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
        });
    }

}

SuperAnalyticsController.$inject = ['$scope', '$timeout', '$parse', 'SSHttpService', 'SSUtilService', 'SSAppService', 'SSAlertService', 'OTPService', 'SSUserService', 'SSDateService'];
app.controller('SuperAnalyticsController', SuperAnalyticsController);

